module.exports = __webpack_public_path__ + "static/media/stella-proxies-map-ip.c583897f.png";